.customActionBar {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	grid-column: 1/-1;
	padding: 0.5rem;
	box-sizing: border-box;
	border-top: 1px solid #e5e7eb;

	& .rightButtons:only-child {
		margin-left: auto;
	}

	& .rightButtons {
		display: flex;
		flex-direction: row;
		gap: 0.5rem;
		align-items: center;
	}

	& :global(.MuiButton-root) {
		min-width: fit-content;
		height: 35px;
	}
}

.pickerRoot {
	grid-template-columns: max-content auto max-content;
}

.openPickerIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	background-color: #f8f8f8;
	border-radius: 6px;
	padding: 0.375rem;
	box-sizing: border-box;

	& svg {
		color: #9864d8;
	}
}
